import {fetchServer, handleFetchError} from "./helpers/functions.js";
import {IOneAnimeJson, IOneAnimeSmallJson} from "../../../nodeserver/structs/database";
import {ServerApi} from "./api.js";
import JSX from "./helpers/react.js";
import AnimeColumn from "./models/AnimeColumn.js";
import RefObject = JSX.RefObject;
import {LoadingSpinner} from "./models/elements/index.js";

let search_value = '';
let search_delay: any;
$(document).on('keyup', 'input[name="word"]', function (event) {
    if (event.keyCode != 40 && event.keyCode != 38) {
        const a = $(this).val()! as string;
        $('input[name="word"]').val(a);
        if (a.length > 0) {
            if (search_value != a && 3 < a.length) {
                clearInterval(search_delay);
                search_delay = setInterval(() => search(a), 300);
            }
        }
    }
})
    .on('keydown', 'input[name="word"]', function (event) {
        //move the active selected menu item
        const activeSearch = $('.live-search');
        if (activeSearch.length > 0) {
            const active = activeSearch.find('li.active');
            if (event.which == 40) { //down
                if (active.length > 0) { //is active
                    active.removeClass('active');
                    active.next().addClass('active');
                } else { //no active
                    activeSearch.find('li:first-child').addClass('active');
                }
            } else if (event.which == 38) { //top
                event.preventDefault();
                if (active.length > 0) { //is active
                    active.removeClass('active');
                    active.prev().addClass('active');
                } else { //no active
                    activeSearch.find('li:last-child').addClass('active');
                }
            } else if (event.which == 13 && active.length > 0) {
                event.preventDefault();
                location.href = activeSearch.find('li.active a').attr('href')!;
            }
        }
    })
    .on('submit', 'form.search-block', function () {
        const that = $(this);
        const text = that.find('input[type=text]').val()! as string;
        if (text.length === 0 || text.length < 3) {
            remove($('.search-tooltip.right-tooltip'))
            // .remove();
            const $el = $(
                <div className="search-tooltip right-tooltip red-tooltip" style={{display: 'block'}}>
                    <div className="tooltip-block-before"/>
                    <div className="tooltip-block">
                        Запрос дожен содержать не менее 3-х символов
                    </div>
                </div>
            )
                .appendTo($(this).parent());
            $el.on('click', remove.bind(0, $el))

            setTimeout(remove.bind(0, $el), 4000);

            function remove($el: JQuery) {
                $el.fadeOut()
                setTimeout(() => $el.remove(), 4500);
            }

            return false;
        }
    })

async function search(a: string) {
    clearInterval(search_delay);
    search_value = a;
    try {
        const data = await ServerApi.anime.search(a);
        let html = <>
            {
                ...data.map(e =>
                    <SearchItem anime={e}/>
                )
            }
        </>;
        if (data.length) {
            $('.live-search-results').attr('href', '/search?word=' + encodeURIComponent(a)).html(<>Открыть все
                результаты <i className="fa fa-search" aria-hidden="true"/></>);
        } else {
            $('.live-search-results').attr('href', '#').html('Ничего не найдено. Попробуйте указать другое название.');
        }

        $('.main-search .live-search').html(html).parent().addClass('open');

        $(document).one('click', function () {
            $('.main-search .live-search').parent().removeClass('open');
        });
    } catch (e) {
        handleFetchError(e);
    }
}

function SearchItem({anime}: { anime: IOneAnimeSmallJson }) {
    return (
        <li>
            <img src={anime.poster.small} className="search-img" alt=""/>
            <a href={`/catalog/item/${anime.anime_url}`}>{anime.title} <span
                className="live-search-year">({anime.year})</span></a>
        </li>
    )
}

function NothingFound({searchQuery}: { searchQuery: string }) {
    const query = `${encodeURIComponent(searchQuery)} site: ${location.hostname}`

    const url = `//google.com/search?q=${query}`;
    return (
        <div className="content-page">
            <div className="center">
                Ничего не найдено.<br/>
                Попробуйте изменить поисковой запрос
                {
                    location.hostname === 'yummyani.me' ? <></> : <> или <a href={url}
                                                                           target="_blank">загуглить</a> аниме</>
                }.

            </div>
        </div>
    )

}

function RetryButton({parent, query, offset}: { parent: HTMLDivElement, offset: number, query: string }) {
    const btn: RefObject<HTMLButtonElement> = {};
    return (
        <div className="center retry-loading-button" ref={btn}>
            <button className="main-button bordered" onClick={() => {
                btn.value!.remove();
                searchAnimesFull(parent, query, offset);
            }}>Загрузить ещё раз
            </button>
        </div>
    )
}

let $loadingEl: JQuery<HTMLDivElement> | null = null;

async function searchAnimesFull(parent: HTMLDivElement, query: string, offset: number = 0) {
    if (parent.classList.contains('blocked')) return;
    if (offset >= 200) {
        if ($loadingEl) {
            $loadingEl.remove();
            $loadingEl = null;
        }
        return;
    }
    if (offset == 0) {
        parent.innerHTML = '';
        $loadingEl = null;
    }
    parent.classList.add('blocked');
    const loading = $loadingEl?.[0] || ($loadingEl = $(<LoadingSpinner large={true}/>))[0];
    try {
        parent.appendChild(loading);
        const animes = await ServerApi.anime.search(query, 20, offset);
        if (!animes.length) {
            $loadingEl!.remove();
            $loadingEl = null
            if (!offset)
                parent.appendChild(<NothingFound searchQuery={query}/>)
        } else {
            Array.from(parent.querySelectorAll('gap') as NodeListOf<HTMLElement>).map(e => e.remove());
            for (const i of animes) {
                parent.appendChild(<AnimeColumn anime={i}/>)
            }
            parent.append(<gap/>, <gap/>, <gap/>);
            parent.removeChild(loading);
            parent.appendChild(loading);
            parent.dataset['offset'] = (offset + 20) + "";
            parent.dataset['q'] = query;
            if (animes.length < 20) {
                $loadingEl!.remove();
                $loadingEl = null;
            }

        }

    } catch (e) {
        handleFetchError(e);
        parent.querySelectorAll('.retry-loading-button').forEach(el => el.remove());
        parent.appendChild(<RetryButton query={query} offset={offset} parent={parent}/>)
        parent.querySelector(".loading")!!.remove();
    } finally {
        parent.classList.remove('blocked');
    }
}


$(function () {
    const el: HTMLDivElement = document.getElementsByClassName('animes-search')[0] as HTMLDivElement;
    if (el) {
        searchAnimesFull(el, el.dataset['q']!)
            .catch(console.error);
        $(document).on('scroll', function () {
            if (!$loadingEl) return;
            if ($loadingEl.isInViewport()) {
                searchAnimesFull(el, el.dataset['q']!, +el.dataset['offset']!);
            }
        })
    }
})
